import React from 'react'
import PropTypes from 'prop-types'

import ChipInput from 'material-ui-chip-input'

export default class ListInput extends React.Component {
  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: [],
  }

  onAdd = (chip) => {
    const v = this.parse(chip)
    if (v !== undefined) {
      this.props.onChange([...this.props.value, v])
    }
  }

  onDelete = (chip, index) => {
    this.props.onChange(this.props.value.filter((_, i) => (i !== index)))
  }

  parse = (v) => (v)

  inputProps = () => ({})

  render() {
    const { value, onChange: _, ...rest } = this.props
    return (
      <ChipInput
        allowDuplicates
        InputProps={this.inputProps()}
        value={value}
        onAdd={this.onAdd}
        onDelete={this.onDelete}
        {...rest}
      />
    )
  }
}
